import type React from 'react';
import ProductOverviewContainer from '../ProductOverview/ProductOverviewContainer';
import type { CartItem } from '../../Store/CartItem/state';
import type { AvailableUpsellGroups } from '../../Store/Upsell/state';

interface OverviewProps {
  availableUpsellGroups: AvailableUpsellGroups;
  cartItems: Record<string, CartItem>;
  onCartItemAmountChange: (cartItemId: string, newAmount: string) => void;
  onCartItemDelete: (cartItemId: string) => void;
  onCartItemMessageDelete: (cartItemId: string) => void;
}

const Overview: React.FC<OverviewProps> = ({
  availableUpsellGroups,
  cartItems,
  onCartItemAmountChange,
  onCartItemDelete,
  onCartItemMessageDelete,
}) => (
  <ProductOverviewContainer
    onCartItemAmountChange={onCartItemAmountChange}
    onCartItemDelete={onCartItemDelete}
    onCartItemMessageDelete={onCartItemMessageDelete}
    products={cartItems}
    availableUpsellGroups={availableUpsellGroups}
  />
);

export default Overview;
